import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { API_URL } from '@/common/config';
// import qs from 'qs';

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
    // Vue.axios.defaults.paramsSerializer = params => qs.stringify(params);
    // axios.defaults.headers.common['dataType'] = 'json';
  },

  get(resource, params) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(resource, params)
        .then(({ error, data }) => {
          if (error.errorno == '0') {
            console.log(data);
            resolve(data);
          } else {
            console.error(error);
            reject(error);
          }
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },
  post(resource, params, con) {
    let config = {
      headers: {
        // 'Content-Type': 'multipart/form-data',
        dataType: 'json',
        ...con
      }
    };
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`${resource}`, params, config)
        .then(({ data }) => {
          let payload = data.data;
          let error = data.error;

          if (error.errorno == '0') {
            console.debug(payload);
            resolve(payload);
          } else {
            console.error(error);
            reject(error);
          }
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  }
};

export default ApiService;
